function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
// TEMPORARY import // todo remove once duya confirms that new api endpoint is 100% correct
// allows us to revert api url if an issue detected.
import TranslationManager from "../translation-manager";

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientOrder = /*#__PURE__*/function () {
  function ApiClientOrder(token) {
    _classCallCheck(this, ApiClientOrder);
    this.token = token;
  }
  return _createClass(ApiClientOrder, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * Place a new order
     */
  }, {
    key: "create",
    value: function create(order) {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.put('/api/orders', order, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Get an order
     */
  }, {
    key: "get",
    value: function get(orderNumber) {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/orders/".concat(orderNumber), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this2.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Get an order confirmation
     */
  }, {
    key: "getOrderConfirmation",
    value: function getOrderConfirmation(orderNumber) {
      var _this3 = this;
      var sendResponseCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var promise = new Promise(function (resolve, reject) {
        axios.get(// `/api/orders/checkout/${orderNumber}`,
        // TODO: TEMPORARY adding url as dictionary item until duya can confirm that new api endpoint is working 100%
        "".concat(TranslationManager.getTranslation('TemporaryOrderConfirmationApiEndpoint')).concat(orderNumber), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          sendResponseCode = err.response.status;
          reject(sendResponseCode);
        });
      });
      return promise;
    }

    /**
     * Get a service order confirmation
     */
  }, {
    key: "getServiceOrderConfirmation",
    value: function getServiceOrderConfirmation(orderNumber) {
      var _this4 = this;
      var sendResponseCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        axios.get("/api/shop/cart/".concat(orderNumber, "/new"), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          sendResponseCode = err.response.status;
          reject(sendResponseCode);
        });
      });
    }

    /**
     * Reorder an order
     */
  }, {
    key: "reorder",
    value: function reorder(orderNumber) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post("/api/orders/reorder/".concat(orderNumber), null, AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this5.token)).then(function () {
          resolve();
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * fetches XML and url for Kaiser users and Ariba Basket
     */
  }, {
    key: "getAribaDetails",
    value: function getAribaDetails(orderNumber) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/shop/cart/ariba-xml?orderNumber=".concat(orderNumber), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
    }
  }]);
}();
export default ApiClientOrder;